import api from './api';

export default {
  downloads: {
    get: async (configurationId: string, type: string): Promise<any> =>
      api.getFile(`/api/configurations/${configurationId}/files/${type}`),
  },
  signAndWorkItemInventor: {
    post: async (configurationId: string, data: any): Promise<any> =>
      api.post(`/api/forge/signandworkiteminventor/${configurationId}`, data),
  },
};
